let deParaLc = lc => {
  if (!lc) {
    return;
  }

  switch (lc?.toLowerCase()) {
    case 'adq':
      lc = 'qua';
      break;
    case 'cdp':
      lc = 'pro';
      break;
    case 'secs':
      lc = 'sep';
    case 'mam':
      lc = 'mam';
      break;
    default:
  }
  return lc;
};

export const IdentificadordoPaciente = (data, periodoSelecionado) => {
  const { linhaDeCuidadoValue, lc, cnes } = data;
  const period = periodoSelecionado.replace('/', '');
  let _lc = deParaLc(lc);

  const identificador = data?.identificadorDoPaciente || data?.numeroRegistro;

  switch (linhaDeCuidadoValue) {
    case 'acidente_vascular_cerebral':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'cancer_de_prostata':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'artropatia_de_quadril':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'sindrome_coronariana_aguda':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'sepse_e_choque_septico':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'cancer_de_mama':
      return String(
        `${_lc}${cnes}${period}${identificador?.padStart(5, '0') || ''}`
      ).toUpperCase();

    case 'dados_faltantes':
      return String(
        `${_lc}${cnes}${period}${data?.identificadorDoPaciente
          ?.toString()
          ?.padStart(5, '0')}`
      ).toUpperCase();

    default:
      return Error('Não foi possível gerar o identificador do paciente.');
  }
};
